import { LOGOUT_SUCCESS } from "../types/authTypes";
import {
  FETCH_ROLE_PERMISSION_ERROR,
  FETCH_ROLE_PERMISSION_LOADING,
  FETCH_ROLE_PERMISSION_SUCCESS,
} from "../types/rolePermissionTypes";

const initState = {
  fetchRolePermissionLoading: false,
  fetchRolePermissionSuccess: false,
  fetchRolePermissionError: false,
  rolePermission: null,
};

const rolePermissionReducer = (state = initState, action) => {
  switch (action.type) {
    case FETCH_ROLE_PERMISSION_LOADING:
        return {
          ...state,
          fetchRolePermissionLoading: true,
          fetchRolePermissionSuccess: false,
          fetchRolePermissionError: false,
          rolePermission: null,
        };
    case FETCH_ROLE_PERMISSION_SUCCESS:
        return {
            ...state,
            fetchRolePermissionLoading: false,
            fetchRolePermissionSuccess: true,
            fetchRolePermissionError: false,
            rolePermission: action.payload,
          };
    case FETCH_ROLE_PERMISSION_ERROR:
        return {
            ...state,
            fetchRolePermissionLoading: false,
            fetchRolePermissionSuccess: false,
            fetchRolePermissionError: true,
            rolePermission: null,
          };
    case LOGOUT_SUCCESS:
      return initState
    default:
      return state;
  }
};

export default rolePermissionReducer;
